import { render, staticRenderFns } from "./PdfBlock.vue?vue&type=template&id=e883d678&scoped=true&"
import script from "./PdfBlock.vue?vue&type=script&lang=js&"
export * from "./PdfBlock.vue?vue&type=script&lang=js&"
import style0 from "./PdfBlock.vue?vue&type=style&index=0&id=e883d678&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e883d678",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e883d678')) {
      api.createRecord('e883d678', component.options)
    } else {
      api.reload('e883d678', component.options)
    }
    module.hot.accept("./PdfBlock.vue?vue&type=template&id=e883d678&scoped=true&", function () {
      api.rerender('e883d678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/PdfBlock.vue"
export default component.exports